import { render, staticRenderFns } from "./HomeScreen.vue?vue&type=template&id=f63a7d76&scoped=true"
import script from "./HomeScreen.vue?vue&type=script&lang=js"
export * from "./HomeScreen.vue?vue&type=script&lang=js"
import style0 from "./HomeScreen.vue?vue&type=style&index=0&id=f63a7d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63a7d76",
  null
  
)

export default component.exports